import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MessagingIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15"><path fillRule="evenodd" d="M.215 10.83c-.589-1.32.073-2.861 1.471-3.426L4.42 6.301l2.368 5.307-.27.11.99 2.217L4.87 15l-.997-2.233c-1.374.449-2.869-.17-3.43-1.428l-.228-.51zM11.132.012c.17.04.31.143.377.294l4.441 9.953c.027.06.054.12.05.194.005.266-.235.489-.515.494l-8.35.529L4.772 6.15 10.664.148a.507.507 0 0 1 .468-.135z"/></svg>
        )
    }
}

export default withCssClassName(MessagingIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/messaging-icon.js